import React from 'react';
import { motion } from 'framer-motion';

const courses = [
    { name: 'Introduction to Web Development', gradient: 'from-indigo-500 to-purple-600' },
    { name: 'Digital Marketing Essentials', gradient: 'from-purple-600 to-pink-500' },
    { name: 'Fundamentals of Graphic Design', gradient: 'from-purple-500 to-red-500' },
    { name: 'Data Science for Beginners', gradient: 'from-pink-500 to-red-500' },
    { name: 'Machine Learning & AI Basics', gradient: 'from-indigo-600 to-red-600' },
    { name: 'Project Management Techniques', gradient: 'from-purple-500 to-orange-500' },
    { name: 'Creative Writing Workshop', gradient: 'from-pink-600 to-yellow-500' },
    { name: 'Business Strategy & Leadership', gradient: 'from-red-500 to-yellow-600' }
  ];
  

const CoursesSection = () => {
  return (
    <div className="my-16 py-10 my-32">
      <h2                       data-aos="fade"
                      data-aos-offset="300"
                      data-aos-duration="1000" className="text-4xl font-bold text-center mb-10 glow-effect">Courses Available</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {courses.map(course => (
          <div
          data-aos="flip-up"
          data-aos-offset="300"
          data-aos-duration="1000"
            className={`course-card rounded-lg overflow-hidden bg-gradient-to-br ${course.gradient}`}
            key={course.name}
          >
            <div className="p-4 h-40 flex items-center justify-center text-center">
              <h3 className="text-xl font-bold text-white">{course.name}</h3>
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .glow-effect {
          text-shadow: 0 0 8px #fff, 0 0 10px #fff, 0 0 20px #08dafa, 0 0 20px #5f01bd;
        }
        .course-card:hover {
          cursor: pointer;
          box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </div>
  );
};

export default CoursesSection;
